import React from 'react'
import Login from '../../components/Login/Login'

function LoginPage() {
    return (
        <div>
           <Login /> 
        </div>
    )
}

export default LoginPage
